import { ActionTypes as uiActionTypes, UiActions } from './ui.actions';
import { PageItem } from "common-lib";
import { ActionWithPayload } from "../../types";

export interface UIState {
  showLoading: boolean;
  availableEntryPages: PageItem[],
  requestsInProgress: {
    [id: string]: number;
  }
}


export const initialState: UIState = {
  showLoading: false,
  availableEntryPages: [],
  requestsInProgress: {},
};


export function reducer(state = initialState, action: UiActions): UIState {
  switch (action.type) {
    case uiActionTypes.SET_ENABLED_ENTRY_PAGES:
      return {
        ...state,
        availableEntryPages: (action as ActionWithPayload<any>).payload,
      };
    case uiActionTypes.SHOW_LOADING:
      return {
        ...state,
        showLoading: true,
      };
    case uiActionTypes.HIDE_LOADING:
      return {
        ...state,
        showLoading: false,
      };
    case uiActionTypes.INCREASE_LOADING_COUNTER:
      const requestStartedUrl = (action as ActionWithPayload<any>).payload;
      let currentRequestsInProgressBefore = {...state.requestsInProgress}
      currentRequestsInProgressBefore[requestStartedUrl] = 0;
      return {
        ...state,
        requestsInProgress: {...currentRequestsInProgressBefore},
      };
    case uiActionTypes.DECREASE_LOADING_COUNTER:
      const requestDoneUrl = (action as ActionWithPayload<any>).payload;
      let currentRequestsInProgressAfter = {...state.requestsInProgress}
      delete currentRequestsInProgressAfter[requestDoneUrl];
      return {
        ...state,
        requestsInProgress: {...currentRequestsInProgressAfter}
      };

    default:
      return state;
  }
}
